import { useEffect } from 'react';
import { MessageLayoutWrapper } from '../MessageMenu';
import { Stack } from 'components/Stack';
import HistoryTable from './components/table/HistoryTable';
import MessagePromptModal from '../common/MessagePromptModal';
import MainMessageComponent from './components/message/MainMessageComponent';
import { useHistoryRequestParams, useSingleHistoryMessage } from './HistoryStore';
import dayjs from 'dayjs';
import { useIsDifferenceStore } from '../common/MessagePromptStore';
import { useSelectingRow } from '../common/CheckSelectStore';

const MessageHistory = () => {
  const { setRequestParams } = useHistoryRequestParams();
  const { setSingleHistoryMessage } = useSingleHistoryMessage();
  const { setIsDifference } = useIsDifferenceStore();
  const { setselectRow } = useSelectingRow();

  // 페이지에서 벗어날 때 초기화 처리
  useEffect(() => {
    return () => {
      // 조회조건 초기화 + 테이블 선택 초기화
      setRequestParams({
        tabType: 'AUTO_MESSAGE',
        recipentType: 'ALL',
        startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        keywordType: 'consigneeName',
        keyword: '',
      });
      setselectRow('');
      setSingleHistoryMessage(null);
      setIsDifference(false);
    };
  }, []);
  return (
    <>
      <MessageLayoutWrapper useVerticalScroll>
        <Stack style={{ width: '60%', minWidth: 900 }}>
          <HistoryTable />
        </Stack>
        <Stack
          style={{
            width: '40%',
            minWidth: 649,
            borderLeft: '2px solid rgb(216, 221, 234)',
          }}
        >
          <MainMessageComponent />
        </Stack>
      </MessageLayoutWrapper>
      <MessagePromptModal />
    </>
  );
};

export default MessageHistory;
